import { render, staticRenderFns } from "./PersonTaskSum.vue?vue&type=template&id=c9acfbc0&scoped=true"
import script from "./PersonTaskSum.vue?vue&type=script&lang=js"
export * from "./PersonTaskSum.vue?vue&type=script&lang=js"
import style0 from "./PersonTaskSum.vue?vue&type=style&index=0&id=c9acfbc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9acfbc0",
  null
  
)

export default component.exports